import { useState } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import ContactsOutlinedIcon from "@mui/icons-material/ContactsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import LocalGroceryStoreIcon from '@mui/icons-material/LocalGroceryStore';
import DashboardIcon from '@mui/icons-material/Dashboard';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import CollectionsIcon from '@mui/icons-material/Collections';
import SpatialTrackingIcon from '@mui/icons-material/SpatialTracking';
import { useDispatch, useSelector } from "react-redux";
import { userHasRole } from "../../slices/auth";
import WebAssetIcon from '@mui/icons-material/WebAsset';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MessageIcon from '@mui/icons-material/Message';

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const ExternalItem = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <a target="_blank" href={to}/>
      {/* <Link to={to} target="_blank"/> */}
    </MenuItem>
  );
};


const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [selected, setSelected] = useState("Dashboard");

  //const currentUser = useSelector((state) => state.auth.user);

  const isAdmin = useSelector(state => userHasRole(state, "SUPER_ADMIN"));

  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);


  //console.log(theme.palette.mode)

  
  var imgSrc = `../../assets/img/Logo_white.png`

  if (theme.palette.mode === "light"){imgSrc = `../../assets/img/Logo.png`}

  return (

    <>

    <Box
      sx={{
        "& .pro-sidebar-inner": {
          background: `${colors.primary[400]} !important`,
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 35px 5px 20px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#868dfb !important",
        },
        "& .pro-menu-item.active": {
          color: "#6870fa !important",
        },
      }}
    >
      <ProSidebar collapsed={isCollapsed}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}
          <MenuItem
            onClick={() => setIsCollapsed(!isCollapsed)}
            icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
            style={{
              margin: "10px 0 20px 0",
              color: colors.grey[100],
            }}
          >
            {!isCollapsed && (

              

              <Box display="flex" justifyContent="space-between" >

                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                    <img
                      alt="Logo"
                      width="35px"
                      height="35px"

                      
                      src={imgSrc}
                      style={{ cursor: "pointer", borderRadius: "50%" }}
                    />
                    <Typography variant="h3" color={colors.grey[100]}>
                      Jazzy Sign
                    </Typography>

                  </Box>

                <Box display="flex">
                <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                  <MenuOutlinedIcon />
                </IconButton>
              </Box>
              </Box>
            )}
          </MenuItem>

          {!isCollapsed && (
            <Box></Box>
          )}

          <Box paddingLeft={isCollapsed ? undefined : "10%"}>

          <Item
              title="Home"
              to="/"
              icon={<HomeOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
            

            

            <Item
              title="Get your Own"
              to="/store"
              icon={<LocalGroceryStoreIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
              title="FAQ Page"
              to="/faq"
              icon={<HelpOutlineOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            {isLoggedIn && (
              <>
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Signs
              
            </Typography>

            <Item
              title="Dashboard"
              to="/dashboard"
              icon={<DashboardIcon />}
              selected={selected}
              setSelected={setSelected}
            />

            <Item
                title="Collections"
                to="/collections"
                icon={<CollectionsIcon />}
                selected={selected}
                setSelected={setSelected}
              />

            <Item
                title="Signs"
                to="/sign"
                icon={<WebAssetIcon />}
                selected={selected}
                setSelected={setSelected}
              />

            
            
            {isAdmin &&(
              <>
              <Typography
                variant="h6"
                color={colors.grey[300]}
                sx={{ m: "15px 0 5px 20px" }}
              >
                Admin
              </Typography>
              
              <Item
                title="User List"
                to="/user"
                icon={<PersonSearchIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="User Sessions"
                to="/admin/user_sessions"
                icon={<VerifiedUserIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="User Roles"
                to="/user_roles"
                icon={<SpatialTrackingIcon />}
                selected={selected}
                setSelected={setSelected}
              />
              <Item
                title="Collection List"
                to="/admin/collection"
                icon={<CollectionsIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="Sign List"
                to="/admin/sign"
                icon={<WebAssetIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="Sign Commands"
                to="/admin/commands"
                icon={<TouchAppIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              <Item
                title="Sign Messages"
                to="/admin/messages"
                icon={<MessageIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              <ExternalItem
                title="API"
                to="https://api.jazzysign.com/swagger"
                icon={<MenuOpenIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              </>
              )}

            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Charts
            </Typography>
            
            </>
            )}
            
          </Box>
        </Menu>
      </ProSidebar>
    </Box>

    </>
  );
};

export default Sidebar;
